import { computed } from 'vue';
import { FeatureFlagName } from './flags';
import { useFeatureFlagsStore } from './store';

export function useFeatureFlag(name: FeatureFlagName) {
  const store = useFeatureFlagsStore();
  return computed(() => store.flags[name]);
}
